    <div class="rss_properties">
    <small class="debug">{{ me }}</small>
    @if (dynamicsInitialized) {
        <div>
            <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
            </dynamic-form>
            <hr/>
            @if (rssEmbeddedDataSource.length > 0) {
                <div>
                    <br/>
                    <mat-label>
                        {{ 'general.embeddedRSS' | transloco }}
                    </mat-label>
                    <br/>
                    <br/>
                    <form [formGroup]="group" floatLabel="never">
                        <app-table-list-input matInput required
                                            (update)="onTableUpdate($event)"
                                            [callBackValue]="onCallBackValue()"
                                            [keepTableIds]="false"
                                            [cloneVals]="true"
                                            [confirmRemove]="false"
                                            [disableDrag]="false"
                                            [tableColumns]="tableColumns"
                                            [inputEditFormat]="{title: 'text', description: 'text'}"
                                            [inputEditRenamePath]="[{path: '$.title', key: 'title'}, {path: '$.description', key: 'description'}]"
                                            [tableClassName]="'rssEmbeddedTableControl'"
                                            [multiSelect]="false"
                                            [rememberSelection]="false"
                                            [allowFilter]="false"
                                            [buttons]="tableButtons"
                                            [expandableEditor]="true"
                                            [formControlName]="'rssEmbeddedTableControl'">
                        </app-table-list-input>
                    </form>
                </div>
            }
            <br/><br/>
            <mat-label>
                {{ 'general.embeddedTitle' | transloco }}
            </mat-label>
            <!--        [hideAlignment]="true"-->

            <div *ngIf="showDescriptionFontSelector">
                <app-font-selector (onChange)="onFontChanged($event, 'Title', 'Rss')" [hideVerticalAlignment]="false"
                                   [setConfig]="{i_config: sceneItem, pickArray: 0}"></app-font-selector>
            </div>
            <div *ngIf="!showDescriptionFontSelector">
                <app-font-selector (onChange)="onFontChanged($event, 'Title', 'Rss')" [showOnlyVertical]="true"
                                   [setConfig]="{i_config: sceneItem, pickArray: 0}"></app-font-selector>
            </div>

            <hr/>
            <mat-label>
                {{ 'general.embeddedDetails' | transloco }}
            </mat-label>
            <br/>
            <!--        [hideAlignment]="true"-->
            @if (showDescriptionFontSelector) {
                <app-font-selector (onChange)="onFontChanged($event, 'Description', 'Rss')" [hideVerticalAlignment]="true"
                                   [setConfig]="{i_config: sceneItem, pickArray: 1}"></app-font-selector>
            }
            <hr/>
        </div>
    }
</div>
